import { render, staticRenderFns } from "./SettingRow.vue?vue&type=template&id=7960a53b"
import script from "./SettingRow.vue?vue&type=script&lang=js"
export * from "./SettingRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports